import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ReactPaginate from "react-paginate";

import clients_api from '../../../api/clients_api';
import DeletePopup from '../../../components/popup/DeletePopup';
import ReadCompanyType from '../../../utils/text-operations/replaceClientType';

import { Edit3, Trash2, Target, UserCheck, Briefcase, Folder, PlusSquare, Home, PhoneCall } from 'react-feather'
import './styles.css'


const ClientDashboard = () => {
  /**
  * Страница клиентов пользователя
  */

  const navigate = useNavigate()

  const [clients, setClients] = useState([]);
  const [page, setPage] = useState(0);
  const [pageCount, setpageCount] = useState(0);

  const [type_company, setTypeCompany] = useState('');

  let currentpage = 1;

  useEffect(() => {
    // Получить всех клиентов при загрузке страницы
    getClients(currentpage, type_company);
  }, [])
  ;

  useEffect(() => {
    // Получить всех клиентов при смене типа клиента
    getClients(currentpage, type_company);
  }, [type_company]);

  const getClients = (page, type_company) => {
    clients_api.getClientsPaginate({
      page: page,
      type_company: type_company,
    })
    .then(res => {
      setpageCount(Math.ceil(res.count / 10));
      setClients(res.results);
    })
    .catch((e) => console.log(e))
}

  const handlePageClick = (data) => {
    // Обработать клик паджинатора
    setPage(data.selected + 1)
    currentpage = data.selected + 1;
    getClients(currentpage, type_company);
  };

  const HandleDelClient = async (id) => {
    await clients_api.deleteClient({ client_id: id, })
      .then(res => {
        console.log(res)
      })
    await getClients(currentpage, type_company);
  }

  const handleChangeCompanyType = (e, val) => {
    e.preventDefault();
    setTypeCompany(val)
  }

  const HandleEditClient = async (
    id,
    title,
    company_type,
    ogrn,
    inn,
    kpp,
    address_reg,
    address_post,
    bill_num,
    bill_corr_num,
    bank_name,
    phone_company,
    results_bik,
    results_ruk,
    image,
    e) => {
      e.preventDefault();
      return navigate("/profile/clients/edit", {state: {
        id,
        title,
        company_type,
        ogrn,
        inn,
        kpp,
        address_reg,
        address_post,
        bill_num,
        bill_corr_num,
        bank_name,
        phone_company,
        results_bik,
        results_ruk,
        image
      }})
  }

  const CreateClient = (e) => {
    e.preventDefault();
    return navigate("/profile/clients/create")
  }

  return (
    <main className="profile-body">

    <div className="container-fluid">
        <div className="page-title">
          <div className="row align-items-center">
            <div className="col my-3 text-start ps-4">
              <h3>Список моих клиентов</h3>
            </div>
            <div className="col-auto">
              <button onClick={(e) => CreateClient(e)} className='btn-create' type="button"><PlusSquare size={16} className='me-2' />Добавить</button>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-md-12 project-list">
          <div className="card-header">
            <div className="row">
              <div className="col-12 p-0">
                <ul className="nav nav-tabs border-tab" id="top-tab" role="tablist">
                  <li className="nav-item"><a className={'nav-link' + (type_company === '' ? ' active' : '')} onClick={(e) => handleChangeCompanyType(e, '')}><Target />Все</a></li>
                  <li className="nav-item"><a className={'nav-link' + (type_company === 'ip' ? ' active' : '')} onClick={(e) => handleChangeCompanyType(e, 'ip')}><Briefcase />ИП</a></li>
                  <li className="nav-item"><a className={'nav-link' + (type_company === 'ooo' ? ' active' : '')} onClick={(e) => setTypeCompany('ooo')}><Folder />ООО</a></li>
                  <li className="nav-item"><a className={'nav-link' + (type_company === 'fiz' ? ' active' : '')} onClick={(e) => setTypeCompany('fiz')}><UserCheck />Физическое лицо</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="col-md-12 project-list">
        <div className="card-header">
            <div className="mt-3">  
                  {clients.map((results) => {
                    return (
                      <div className="row text-start my-2 mx-0" key={results.id}>
                        <div className="col-10 my-0 mx-0">
                          <div className="row my-0 mx-0">
                            <div className="col-md-4">
                              <label>{ReadCompanyType(results.company_type)}: <b>{results.title}</b></label>
                            </div>
                            <div className="col-md-3">
                              <label><Home size='16px' color='gray'/> {results.address_reg}</label>
                            </div>
                            <div className="col-md-2">
                              {results.phone_company && <label className="text-nowrap"><PhoneCall size='16px' color='gray' className="me-1"/> {results.phone_company}</label>}
                            </div>
                          </div>
                        </div>
                        <div className="col-2 my-0 mx-0">
                          <div className="d-flex gap-1 justify-content-end">
                            <button className="action-btn" onClick={(e) => HandleEditClient(
                            results.id,
                            results.title,
                            results.company_type,
                            results.ogrn,
                            results.inn,
                            results.kpp,
                            results.address_reg,
                            results.address_post,
                            results.bill_num,
                            results.bill_corr_num,
                            results.bank_name,
                            results.phone_company,
                            results.bik,
                            results.ruk,
                            results.image,
                            e)}><Edit3 size={18} color="#f59e0b"/></button>
                            <DeletePopup InputIcon={Trash2} color="#e53e3e" name={results.title} action={HandleDelClient} id={results.id}/>
                          </div>
                        </div>


                        <hr className='mt-2'></hr>
                      </div>
                      );
                    })}
             


              <ReactPaginate
              previousLabel={"предыдущая"}
              nextLabel={"следующая"}
              initialPage={page}
              breakLabel={"..."}
              pageCount={pageCount}
              marginPagesDisplayed={2}
              pageRangeDisplayed={3}
              onPageChange={handlePageClick}
              containerClassName={"pagination justify-content-center"}
              pageClassName={"page-item"}
              pageLinkClassName={"page-link"}
              previousClassName={"page-item"}
              previousLinkClassName={"page-link"}
              nextClassName={"page-item"}
              nextLinkClassName={"page-link"}
              breakClassName={"page-item"}
              breakLinkClassName={"page-link"}
              activeClassName={"active"}
            />

          </div>
        </div>
      </div>

    </main>
  );
};

export default ClientDashboard;
